import $ from 'jquery';
import renderForm from '../form';
import { DROPDOWN_SETTINGS } from 'plugins/bootstrap';
import { displayCreate as displayCreateSite } from 'saas/sites/api';
import { displayCreationModal as displayCreateCustomer } from 'saas/customers/modals';

export const create = () => {
  handleCustomerSelector(bindNewDemandForm);
};

export function handleCustomerSelector(bindCustomerForm) {
  const $customers = $('#customerId').closest('.dropdown');
  const $currentCustomer = $('#root').data('customer');

  const initDropdown = () => {
    return $customers.dropdown({
      ...DROPDOWN_SETTINGS,
      onChange: customer => onCustomerSelected(customer, bindCustomerForm),
    });
  };

  initDropdown();

  const onCustomerSaved = customer => {
    $customers
      .find('.menu')
      .append(
        `<div class="item" data-value="${customer.id}">${customer.name}</div>`
      );

    initDropdown().dropdown('set selected', customer.id);
  };

  // Handling customer creation
  $('#bt-new-customer').on('click', evt =>
    displayCreateCustomer(evt, onCustomerSaved)
  );

  if ($currentCustomer) {
    initDropdown().dropdown('set selected', $currentCustomer);
  }
}

function onCustomerSelected(customer, bindCustomerForm) {
  const $noCustomer = $('#info-no-customer');
  const $btSave = $('#bt-save');
  const $form = $('#case-form');

  if (customer) {
    $noCustomer.hide();
    $btSave.removeClass('disabled');

    // Adding customer id to DOM data context
    $('#root').attr('data-customer', customer);

    // Loading add site modal
    displayCreateSite(customer)
      .then(modal => $(document.body).append(modal))
      .then(_ => bindCustomerForm($form, customer));
  } else {
    $noCustomer.show();
    $btSave.addClass('disabled');
  }
}

function bindNewDemandForm($form, customer, monoSite = false) {
  // Setting form action
  $form.attr('action', `/pco-manager/cases/demand/new?customer_id=${customer}`);

  // Launching case React app
  renderForm(undefined, monoSite, true);
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/demand/index.js